import { useContent } from "../../hooks/useContent";
import { GetRootNavigationItem } from "../../queries/GetRootNavigationItem";
import { Navigation } from "./navigation/Navigation";

export const Header = () => {
  const [response] = useContent({ query: GetRootNavigationItem });

  if (response.fetching) {
    return (
      <Navigation
        root={response.data?.navigationItemCollection?.items[0] ?? null}
        loading={response.fetching}
      />
    );
  } else {
    const root = response.data?.navigationItemCollection?.items[0] ?? null;
    if (!root) {
      console.error("Root navigation has failed to resolve: ", response);
    }

    return <Navigation root={root} loading={false} />;
  }
};
